import { render } from "./CoursePanelMoreContextButton.vue?vue&type=template&id=4fffd693&scoped=true"
import script from "./CoursePanelMoreContextButton.vue?vue&type=script&lang=js"
export * from "./CoursePanelMoreContextButton.vue?vue&type=script&lang=js"

import "./CoursePanelMoreContextButton.vue?vue&type=style&index=0&id=4fffd693&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fffd693"]])

export default __exports__